// extracted by mini-css-extract-plugin
module.exports = {"DesktopWarapperTopShopper":"SYtg4"};